import React from "react";
import "../css/Vision.css";

const Vision = () => {

    return (

        <section
            id="vision-component"
            className="esc-vision-section"
        >

            <div className="esc-vision-container">

                <h2 className="esc-vision-title">

                    Visión

                </h2>

                <div className="esc-vision-card">

                    <p className="esc-vision-description">

                        Aspiramos a constituirnos en una comunidad educativa democrática, tolerante y respetuosa,
                        que considera la realidad sociocultural de estudiantes y familias, para promover la creatividad
                        y el respeto por el entorno, mediante experiencias educativas innovadoras, desafiantes y
                        contextualizadas, aportando a la formación subjetiva e identitaria de NNA.

                    </p>

                </div>

            </div>

        </section>

    );

};

export default Vision;